import { useEffect, useState } from 'react';

import { useFormContext } from 'react-hook-form';

import { CustomFilterFormValues } from '../AddCustomFilterForm.settings';
import { isEmptyValue } from '../../../../../../utils/jsUtils';
import {
  CustomFilterType,
  CustomFilterByType,
} from '../../../../interfaces/CustomFilterData';

export type ClearFields<TFilter extends CustomFilterType> = Omit<
  CustomFilterByType<TFilter>,
  'filterType'
>;

export const useClearFilter = <TFilter extends CustomFilterType>(
  filter: TFilter,
  clearFields: ClearFields<TFilter>,
) => {
  const [disabled, setDisabled] = useState(true);

  const { watch, setValue } = useFormContext<CustomFilterFormValues>();

  const fieldNames = Object.keys(clearFields).map(
    (field) => `filters.${filter}.${field}` as any,
  );

  const fieldsValue = watch(fieldNames);

  const handleClearFields = () => {
    setValue(`filters.${filter}`, {
      ...clearFields,
      filterType: filter,
    } as any);
  };

  useEffect(() => {
    const isAllFieldEmpty = fieldsValue.every(isEmptyValue);
    setDisabled(isAllFieldEmpty);
  }, [fieldsValue]);

  return { handleClearFields, disabled };
};
